/**
 * This file holds actions. The actions commit mutations and can perform asynchronous operations.
 * Please refer to https://vuex.vuejs.org/guide/actions.html for more information
 */
import http from "@/http";
import * as types from "./types";

const actions = {
  [types.GET_GROUP_TABS](context) {
    const { tabListData, tabListDataDB, s3Tabs } = this.state.endPoints.customizer;
    const enablePerformanceLogging = this.state.utils.queryParams.enablePerformanceLogging || this.state.utils.configuration.enablePerformanceLogging

    let requestUrl = tabListData;
    if (this.state.utils.configuration.enableDBTabs) {
      requestUrl = tabListDataDB;
    } else if(this.state.utils.configuration.enableTabsInS3) {
      requestUrl = `${s3Tabs}customizer-tabs.json`;
    }
    return new Promise((resolve, reject) => {
      http
        .get(context.rootGetters['utils/addCacheBusting'](requestUrl))
        .then(({ data }) => {
          context.commit(types.SET_GROUPS, data);
          context.dispatch('wait/end', 'loading tabs', { root: true });
          if(enablePerformanceLogging)
            console.log("Tabs Ready: ", new Date().getTime() / 1000 - this.state.utils.initialTime);
          resolve(data);
        })
        .catch(reject);
    });
  },
  [types.GET_SUBGROUP_TABS](context, path) {
    const enablePerformanceLogging = this.state.utils.queryParams.enablePerformanceLogging || this.state.utils.configuration.enablePerformanceLogging;
    const { s3Tabs, s3Url } = this.state.endPoints.customizer;
    const requestUrl = this.state.utils.configuration.enableTabsInS3 ?
      `${s3Tabs}${path}` : `${s3Url}${path}`;
    return new Promise((resolve, reject) => {
      http
        .get(context.rootGetters['utils/addCacheBusting'](requestUrl))
        .then(({ data }) => {
          context.dispatch('wait/end', 'loading subgroups', { root: true });
          if(enablePerformanceLogging)
            console.log("subgroups Ready: ", new Date().getTime() / 1000 - this.state.utils.initialTime);
          resolve(data);
        })
        .catch(reject);
    });
  },
  [types.GET_AVAILABLE_SWATCHES_BY_COMPONENT](
    { dispatch, commit, rootGetters },
    { component, isApparelEnabled },
    activeComponent = `${this.state.legacyNavigation.activeComponent}`
  ) {
    const { region, locale } = this.state.utils.configuration;
    let isAComponent = false;

    activeComponent = component ?? activeComponent;
    let requestUrl = `${this.state.endPoints.customizer.s3Url}/content/vans-custom-product-data-models/${
        region}/${locale}/${this.state.utils.pdm.sku
        }/components/${activeComponent}.available_swatches.all.json`;

    // Temporary change for TMALL would be removed when swatches in db is live
    if(rootGetters['utils/tmallEnabled']) {
      requestUrl = `${this.state.endPoints.customizer.s3Url
      }/available_swatches/${this.state.utils.pdm.sku}/components/${
      activeComponent}.available_swatches.all.json`;
    }

    if(this.state.utils.configuration.enableDBSwatches){
      requestUrl = `${this.state.endPoints.customizer.availableSwatchesDB}${
      this.state.utils.pdm.sku}/${activeComponent}`;

      if(this.state.utils.configuration.enableS3Customizer){
        requestUrl = `${requestUrl}.json`.replace(this.state.utils.configuration.domain,'');
      }
    }

    if (isApparelEnabled) {
      if (!component && !this.state.legacyNavigation.activeComponent &&
        !this.state.standardNavigation.activeComponent) {
        return;
      }

      if (!component) {
        activeComponent = !!this.state.standardNavigation.activeSubComponent ?
          `${this.state.standardNavigation.activeComponent}/${this.state.standardNavigation.activeSubComponent}`
          : this.state.legacyNavigation.activeComponent;
      }

      isAComponent = !this.state.standardNavigation.activeSubComponent || !!component;
    }

    return new Promise((resolve, reject) => {
      const currentSwatchesByComponent = this.state.swatches.swatchesByComponent[activeComponent];
      if (currentSwatchesByComponent && String(activeComponent).search('/') === -1) {
        resolve(currentSwatchesByComponent)
      } else {
        if (isAComponent || !isApparelEnabled) {
          http
          .get(rootGetters['utils/addCacheBusting'](requestUrl))
          .then(({ data }) => {
          if (!component && !!this.state.standardNavigation.activeSubComponent) {
            activeComponent = this.state.standardNavigation.activeComponent;
          }
          commit(types.SET_AVAILABLE_SWATCHES_BY_COMPONENT, {
            component: activeComponent,
            swatches: data
          });
          let swatches = [];
          for(let group in data) {
            for(let subgroup in data[group]) {
            swatches = swatches.concat(data[group][subgroup]);
            }
          }
          commit(types.SET_LIST_SWATCHES_BY_COMPONENT, {
            component: activeComponent,
            swatches: swatches
          });
          resolve(data);
          }).catch(reject);
        } else {
          let subComponent = {};
          if (this.state.standardNavigation.activeSubComponent !== '') {
           const component = this.state.gdm.data.find(item => item.component3D ===  this.state.standardNavigation.activeComponent);
           subComponent = component?.component?.find(item => item.id ===  this.state.standardNavigation.activeSubComponent);
          }
          const data = this.state.gdm.config[0]?.global.available_swatches;
          commit(types.SET_AVAILABLE_SWATCHES_BY_COMPONENT, {
            component: 'sub_component',
            swatches: data
          });

          let swatches = [];
          for(let group in data) {
            for(let subgroup in data[group]) {
            swatches = swatches.concat(data[group][subgroup]);
            }
          }
          commit(types.SET_LIST_SWATCHES_BY_COMPONENT, {
          component: 'sub_component',
          swatches: swatches
          });
          resolve(data);
        }
      }
      });
  },
  [types.GET_PALETTES](context, palette) {
    const enablePerformanceLogging = this.state.utils.queryParams.enablePerformanceLogging || this.state.utils.configuration.enablePerformanceLogging
    const requestUrl = `${this.state.endPoints.customizer.palette}/${palette}`;
    return new Promise((resolve, reject) => {
      http
        .get(context.rootGetters['utils/addCacheBusting'](requestUrl))
        .then(({ data }) => {
          context.commit(types.SET_PALETTES, data);
          context.commit(types.SET_SWATCHES_IN_PALETTES, data.swatches);
          if (data.palette_features) {
            context.commit(types.SET_PALETTE_THEME, data);
          }
          const { hidden_features } = data
          if (hidden_features) {
            let features = {}
            for (let item in hidden_features) {
              if (hidden_features[item]) {
                features[item] = hidden_features[item];
              }
            }
            context.commit(types.SET_PALETTES_HIDDEN_FEATURES, features)
          }
          context.dispatch('wait/end', 'loading palettes', { root: true });
          if (enablePerformanceLogging)
            console.log("palettes Ready: ", new Date().getTime() / 1000 - this.state.utils.initialTime);
          resolve(data);
        })
        .catch(err => {
          console.error(`Error getting palette id: ${palette}`, err);
          reject(err);
        });
    });
  },
  [types.GET_RELATION_SWATCH_BY_SWATCH]({ commit, state, rootGetters }, swatchId) {
    const requestUrl = `${this.state.endPoints.customizer.swatchesRelation}`;

    const params = { swatchId };

    return new Promise((resolve, reject) => {
      const currentSwatch = state.swatchesRelation[swatchId];
      currentSwatch ?
        resolve(currentSwatch) :
        http
          .get(rootGetters['utils/addCacheBusting'](requestUrl), { params })
          .then(({ data }) => {
            commit(types.SET_SWATCHES_RELATION, data);
            resolve(data);
          })
          .catch(reject);
    });
  },
  [types.GET_RELATION_SWATCH_BY_RECIPE_ID](context, recipeId) {
    const requestUrl = `${this.state.endPoints.customizer.swatchesRelation}`;
    const params = { recipeId };
    return new Promise((resolve, reject) => {
      http
        .get(context.rootGetters['utils/addCacheBusting'](requestUrl), { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  [types.GET_RELATION_SWATCH_BY_FEATURE_ID](context, featureId) {
    const requestUrl = `${this.state.endPoints.customizer.swatchesRelation}`;
    const params = { featureId };
    return new Promise((resolve, reject) => {
      http
        .get(context.rootGetters['utils/addCacheBusting'](requestUrl), { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  [types.GET_AEM_MODAL_CONTENT](context, requestUrl) {
    return new Promise((resolve, reject) => {
      http
        .get(context.rootGetters['utils/addCacheBusting'](requestUrl))
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  }
};

export default actions;
